<aca-page-layout>
  <aca-page-layout-header>
  </aca-page-layout-header>

  <aca-page-layout-content>
    <div class="wk-semantic-search-results">
      <mat-progress-bar class="wk-semantic-search-results__loader"
        [class.wk-semantic-search-results__loader--hidden]="!isLoading" color="primary" mode="indeterminate"
        aria-live="polite"></mat-progress-bar>

      <div class="wk-semantic-search-results__scroll-container">
        <div class="wk-semantic-search-results__list">
          <div class="wk-semantic-search-results__item" *ngFor="let result of results">
            <div class="wk-semantic-search-results__item-header">
              <a class="wk-semantic-search-results__item-title" (click)="openPreview(result)"
                [title]="getTitle(result)">
                {{ getTitle(result) }}
              </a>
            </div>
            <p class="wk-semantic-search-results__item-snippet">
              {{ getSnippet(result) }}
            </p>
          </div>
        </div>

        <div class="wk-semantic-search-results__empty" *ngIf="!isLoading && results.length === 0 && searchQuery">
          <mat-icon>search_off</mat-icon>
          <p>{{ 'SEARCH.SEMANTIC.NO_RESULTS' | translate }}</p>
        </div>

      </div>


    </div>
  </aca-page-layout-content>
</aca-page-layout>